var _this2 = this;

export default ((func, wait) => {
    let timeout;
    return (...args) => {
        const _this = _this2;
        const _args = args;

        const later = () => {
            timeout = null;
            func.apply(_this, _args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
});


// WEBPACK FOOTER //
// ./~/pluton-core/lib/utils/debounce.js